'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactBodymovin = require('react-bodymovin');

var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var unfavoritingAnimation = {
    v: '5.1.1',
    fr: 29.9700012207031,
    ip: 0,
    op: 78.0000031770051,
    w: 50,
    h: 50,
    nm: 'Quality-Ae',
    ddd: 0,
    assets: [],
    layers: [{
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: 'Pencil Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: -3,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 29, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0]],
                        v: [[1.163, -2.924], [2.924, 2.924], [-2.924, 1.162]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [24.781, 36.886],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-7.749, -7.749], [7.749, 7.749]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [16.152, 28.256],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 3,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-2.043, 2.043], [2.043, -2.043]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [8.402, 20.506],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 3,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [-0.944, 0.943], [0, 0], [-0.944, -0.943]],
                        o: [[0, 0], [0, 0], [-0.944, -0.944], [0, 0], [0.944, -0.943], [0, 0]],
                        v: [[3.294, -0.793], [-0.792, 3.293], [-2.35, 1.736], [-2.35, -1.681], [-1.682, -2.35], [1.736, -2.35]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [5.602, 17.707],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 4',
            np: 3,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[10.568, 6.481], [6.482, 10.567], [-10.568, -6.481], [-6.48, -10.567]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [15.376, 27.481],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 3,
            cix: 2,
            ix: 5,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: 'Zig zag Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 1,
                k: [{
                    i: {
                        x: [0.414],
                        y: [0.983]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p414_0p983_0p167_0p167'],
                    t: 4,
                    s: [0],
                    e: [41]
                }, {
                    i: {
                        x: [0],
                        y: [1.437]
                    },
                    o: {
                        x: [0.782],
                        y: [0.696]
                    },
                    n: ['0_1p437_0p782_0p696'],
                    t: 20,
                    s: [41],
                    e: [41]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.682],
                        y: [0.012]
                    },
                    n: ['0p833_0p833_0p682_0p012'],
                    t: 32,
                    s: [41],
                    e: [0]
                }, {
                    t: 51.0000020772726
                }],
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [30.105, 7.202],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [27.483, 9.799],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 2,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [24.861, 12.397],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [22.238, 14.995],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 4',
            np: 2,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [19.615, 17.592],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 2,
            cix: 2,
            ix: 5,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [16.993, 20.191],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 6',
            np: 2,
            cix: 2,
            ix: 6,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [14.37, 22.788],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 2,
            cix: 2,
            ix: 7,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [11.748, 25.386],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 8',
            np: 2,
            cix: 2,
            ix: 8,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-0.755, -0.755], [0.755, 0.755]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [9.126, 27.984],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 9',
            np: 2,
            cix: 2,
            ix: 9,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0]],
                        v: [[8.971, 8.971], [0.089, 8.971], [8.971, 0.089]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ind: 1,
                ty: 'sh',
                ix: 2,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0]],
                        v: [[-15.378, 15.378], [15.378, 15.378], [15.378, -15.378]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 2',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'mm',
                mm: 1,
                nm: 'Merge Paths 1',
                mn: 'ADBE Vector Filter - Merge',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [18.723, 16.877],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 10',
            np: 5,
            cix: 2,
            ix: 10,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: 'Lines Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[-6.182, 7.941], [6.182, -7.941]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                d: [{
                    n: 'd',
                    nm: 'dash',
                    v: {
                        a: 0,
                        k: 0.25,
                        ix: 1
                    }
                }, {
                    n: 'g',
                    nm: 'gap',
                    v: {
                        a: 0,
                        k: 2,
                        ix: 2
                    }
                }, {
                    n: 'o',
                    nm: 'offset',
                    v: {
                        a: 0,
                        k: 0,
                        ix: 7
                    }
                }],
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [40.343, 29.54],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[44.518, 40.767], [44.643, 40.767]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 2,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[38.225, 40.767], [43.586, 40.767]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                d: [{
                    n: 'd',
                    nm: 'dash',
                    v: {
                        a: 0,
                        k: 0.233,
                        ix: 1
                    }
                }, {
                    n: 'g',
                    nm: 'gap',
                    v: {
                        a: 0,
                        k: 1.865,
                        ix: 2
                    }
                }, {
                    n: 'o',
                    nm: 'offset',
                    v: {
                        a: 0,
                        k: 0,
                        ix: 7
                    }
                }],
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[36.235, 40.767], [36.36, 40.767]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 4',
            np: 2,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -3.951], [3.951, 0], [0, 3.952], [-3.952, 0]],
                        o: [[0, 3.952], [-3.952, 0], [0, -3.951], [3.951, 0]],
                        v: [[7.155, 0], [0.001, 7.155], [-7.155, 0], [0.001, -7.155]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [39.412, 30.73],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 3,
            cix: 2,
            ix: 5,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -1.051], [1.05, 0], [0, 1.051], [-1.051, 0]],
                        o: [[0, 1.051], [-1.051, 0], [0, -1.051], [1.05, 0]],
                        v: [[1.902, 0], [0.001, 1.902], [-1.902, 0], [0.001, -1.902]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [32.258, 40.466],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 6',
            np: 3,
            cix: 2,
            ix: 6,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0]],
                        v: [[3.439, 3.439], [-3.439, 3.439], [-3.439, -3.439]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [45.012, 15.998],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 3,
            cix: 2,
            ix: 7,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[-14.499, -17.171], [7.473, -17.171], [14.499, -10.294], [14.499, 17.171], [-14.499, 17.171]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [34.1, 29.731],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 8',
            np: 3,
            cix: 2,
            ix: 8,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [25.071, 25.898],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 9',
            np: 2,
            cix: 2,
            ix: 9,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }],
    markers: []
};


var QualityIcon = function QualityIcon(_ref) {
    var autoplay = _ref.autoplay;


    var QualityIconContainer = _styledComponents2.default.div(_templateObject);

    var bodymovinOptions = {
        loop: true,
        autoplay: { autoplay: autoplay },
        prerender: true,
        animationData: unfavoritingAnimation
    };

    return _react2.default.createElement(
        QualityIconContainer,
        null,
        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
    );
};

exports.default = QualityIcon;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Icons/QualityIcon.js
// module id = 478
// module chunks = 87895327789742